// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `content {
  display: block;
  max-width: 900px;
  margin: 0 auto;
}

button[mat-button] {
  /* text-transform: uppercase; */
}

.toolbar-search {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin: 0 0.5em 0 0.5em;
}

div.footer-spacing {
  height: 50vh;
  width: 100vh;
  /*
  styles.scss sets the height of html and body which makes things peculiar for scrolling pages...
  */
}

/* styles.css */
.primary {
  background-color: white;
  color: gray;
}

.secondary {
  background-color: gray;
  color: white;
}

.debug {
  display: none;
}

* {
  box-sizing: border-box;
}

header {
  display: flex;
}
header h1 {
  flex: auto;
  text-transform: capitalize;
}
header button {
  align-self: center;
}

.mat-mdc-table {
  width: 100%;
  border-collapse: collapse;
}
.mat-mdc-table .mat-mdc-row,
.mat-mdc-table .mat-mdc-header-row,
.mat-mdc-table .mat-mdc-footer-row {
  /* height: 32px; */
}
.mat-mdc-table .mat-mdc-row > .mat-mdc-header-cell,
.mat-mdc-table .mat-mdc-header-row > .mat-mdc-header-cell,
.mat-mdc-table .mat-mdc-footer-row > .mat-mdc-header-cell {
  font-weight: bold;
}
.mat-mdc-table .mat-mdc-row > .mat-mdc-cell, .mat-mdc-table .mat-mdc-row > .mat-mdc-header-cell,
.mat-mdc-table .mat-mdc-header-row > .mat-mdc-cell,
.mat-mdc-table .mat-mdc-header-row > .mat-mdc-header-cell,
.mat-mdc-table .mat-mdc-footer-row > .mat-mdc-cell,
.mat-mdc-table .mat-mdc-footer-row > .mat-mdc-header-cell {
  padding: 0 1rem;
  min-width: 16rem;
}
.mat-mdc-table .mat-mdc-row > .mat-mdc-cell:first-of-type, .mat-mdc-table .mat-mdc-row > .mat-mdc-header-cell:first-of-type,
.mat-mdc-table .mat-mdc-header-row > .mat-mdc-cell:first-of-type,
.mat-mdc-table .mat-mdc-header-row > .mat-mdc-header-cell:first-of-type,
.mat-mdc-table .mat-mdc-footer-row > .mat-mdc-cell:first-of-type,
.mat-mdc-table .mat-mdc-footer-row > .mat-mdc-header-cell:first-of-type {
  padding-left: 4rem;
}
.mat-mdc-table .mat-mdc-row > .mat-mdc-cell:last-of-type, .mat-mdc-table .mat-mdc-row > .mat-mdc-header-cell:last-of-type,
.mat-mdc-table .mat-mdc-header-row > .mat-mdc-cell:last-of-type,
.mat-mdc-table .mat-mdc-header-row > .mat-mdc-header-cell:last-of-type,
.mat-mdc-table .mat-mdc-footer-row > .mat-mdc-cell:last-of-type,
.mat-mdc-table .mat-mdc-footer-row > .mat-mdc-header-cell:last-of-type {
  padding-right: 4rem;
}
.mat-mdc-table .mat-mdc-row > .mat-mdc-cell.cpd.edit, .mat-mdc-table .mat-mdc-row > .mat-mdc-header-cell.cpd.edit,
.mat-mdc-table .mat-mdc-header-row > .mat-mdc-cell.cpd.edit,
.mat-mdc-table .mat-mdc-header-row > .mat-mdc-header-cell.cpd.edit,
.mat-mdc-table .mat-mdc-footer-row > .mat-mdc-cell.cpd.edit,
.mat-mdc-table .mat-mdc-footer-row > .mat-mdc-header-cell.cpd.edit {
  min-width: 0;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/components/reference-table/reference-table.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,+BAAA;AACF;;AAEA;EACE,aAAA;EACA,qCAAA;EACA,uBAAA;AACF;;AAGA;EACE,YAAA;EACA,YAAA;EAEA;;GAAA;AACF;;AAIA,eAAA;AACA;EACE,uBAAA;EACA,WAAA;AADF;;AAIA;EACE,sBAAA;EACA,YAAA;AADF;;AAIA;EACE,aAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,aAAA;AADF;AAGE;EACE,UAAA;EACA,0BAAA;AADJ;AAGE;EACE,kBAAA;AADJ;;AAKA;EACE,WAAA;EACA,yBAAA;AAFF;AAIE;;;EAKE,kBAAA;AAJJ;AAMI;;;EACE,iBAAA;AAFN;AAKI;;;;;EAEE,eAAA;EACA,gBAAA;AAAN;AAEM;;;;;EACE,kBAAA;AAIR;AAFM;;;;;EACE,mBAAA;AAQR;AALM;;;;;EACE,YAAA;AAWR;AACA,guFAAguF","sourcesContent":["content {\n  display: block;\n  max-width: 900px;\n  margin: 0 auto;\n}\n\nbutton[mat-button] {\n  /* text-transform: uppercase; */\n}\n\n.toolbar-search {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  margin: 0 0.5em 0 0.5em;\n}\n\n// :root::after,\ndiv.footer-spacing {\n  height: 50vh;\n  width: 100vh;\n\n  /*\n\tstyles.scss sets the height of html and body which makes things peculiar for scrolling pages...\n\t*/\n}\n\n/* styles.css */\n.primary {\n  background-color: white;\n  color: gray;\n}\n\n.secondary {\n  background-color: gray;\n  color: white;\n}\n\n.debug {\n  display: none;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nheader {\n  display: flex;\n\n  h1 {\n    flex: auto;\n    text-transform: capitalize;\n  }\n  button {\n    align-self: center;\n  }\n}\n\n.mat-mdc-table {\n  width: 100%;\n  border-collapse: collapse;\n\n  .mat-mdc-row,\n  .mat-mdc-header-row,\n  .mat-mdc-footer-row {\n    // white-space: nowrap;\n    // padding: 0rex 4rem;\n    /* height: 32px; */\n\n    & > .mat-mdc-header-cell {\n      font-weight: bold;\n    }\n\n    & > .mat-mdc-cell,\n    & > .mat-mdc-header-cell {\n      padding: 0 1rem;\n      min-width: 16rem;\n\n      &:first-of-type {\n        padding-left: 4rem;\n      }\n      &:last-of-type {\n        padding-right: 4rem;\n      }\n\n      &.cpd.edit {\n        min-width: 0;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
